__turbopack_context__.v({
  "carouselColumn": "ProfileRow-module-scss-module__ZELFEG__carouselColumn",
  "chevron": "ProfileRow-module-scss-module__ZELFEG__chevron",
  "grid": "ProfileRow-module-scss-module__ZELFEG__grid",
  "leading": "ProfileRow-module-scss-module__ZELFEG__leading",
  "meta": "ProfileRow-module-scss-module__ZELFEG__meta",
  "metaIcon": "ProfileRow-module-scss-module__ZELFEG__metaIcon",
  "metaText": "ProfileRow-module-scss-module__ZELFEG__metaText",
  "row": "ProfileRow-module-scss-module__ZELFEG__row",
  "rowList": "ProfileRow-module-scss-module__ZELFEG__rowList",
  "text": "ProfileRow-module-scss-module__ZELFEG__text",
  "title": "ProfileRow-module-scss-module__ZELFEG__title",
});
